module.exports = __webpack_public_path__ + "img/claim-success-coupon.f049c234.png";